import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from '../Redux/Actions/AuthActions';
import './Login.css';
import logo from "../image/LOGOTASKOPOS.jpg";

const Login = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [matricule, setMatricule] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = (a) => {
    a.preventDefault();
    dispatch(login({ email, password, matricule }, navigate));
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 register-background">
      <h1>Welcome to  <img src={logo} alt="Mon logo" className="mb-4" style={{ width: '80px' }} /> </h1>
      <div className="register-container shadow rounded p-5 text-center">
        <div>

          <img src={logo} alt="Mon logo" className="mb-4" style={{ width: '180px' }} />

        </div>

        <Form onSubmit={handleLogin}>
          <Form.Group className="mb-3">
            <Form.Label>Matricule</Form.Label>
            <Form.Control
              onChange={(e) => setMatricule(e.target.value)}
              type="text"
              placeholder="Votre matricule"
              value={matricule}
              className="input-field"
            />
          </Form.Group>



          <Form.Group className="mb-3">
            <Form.Label>Adresse Email</Form.Label>
            <Form.Control
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="Votre email"
              value={email}
              className="input-field"
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>Mot de passe</Form.Label>
            <Form.Control
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="Votre mot de passe"
              value={password}
              className="input-field"
            />
          </Form.Group>

          <Button variant="primary" type="submit" className="w-100 btn-submit">
            Se connecter
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default Login;
